//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // list:[{title: '适用人群',cont:'适用于18-60周岁的人群'}]
    }
  },
  props: {
    list: {
      type: Array,
      required:true
    },
    moreList: {
        type: Array,
        default() { return []}
    },
    link:{
      type: Boolean,
      default:false
    }
  },
  methods:{
    liClick(item){
      if(this.link){
        this.$emit('liClick',item)
      }
    }
  }
}
